<template>
    <div class="body-panel dataContent">
        <div class="body-panel-control separator"
             v-if="info.User && (info.User.MainRole === 'administrators' || hasClaims(info.User.DynamicRole, claimEnums.motivationEdit) || info.ProjectsLength > 1)">
            <div class="control-block-left" v-if="info.User && (info.User.MainRole === 'administrators' || info.ProjectsLength > 1)">
                <div class="flex">
                    <project-select :user="info.User" @onChange="onProjectChange"></project-select>
                </div>
            </div>
            <div class="control-block-right" v-if="info.User.MainRole === 'administrators' || hasClaims(info.User.DynamicRole, claimEnums.motivationEdit)">
                <div class="btns flex">
                    <input type="file" id="dropFiles" ref="dropFiles" name="dropFiles"
                           class="file-upload-zone-btn" accept=".pdf" @change="onFileChange()" />
                    <button type="button" class="btn" onclick="document.getElementById('dropFiles').click()">Загрузить презентацию</button>
                    <button type="button" class="btn btn-delete" @click="deleteMotivation()" v-if="project != null && project.MotivationFile != null">Удалить презентацию</button>
                    <button type="button" class="btn" @click.stop="onShowModal('ppYoutubeLink')">Видео</button>
                    <button type="button" class="btn btn-delete" @click="onDeleteYoutubeLink()" v-if="project != null && (project.MotivationYoutubeLink || project.MotivationVideoPath)">Удалить видео</button>
                </div>
            </div>
        </div>
        <div class="body-panel-content body-panel-content-page" v-if="project != null">
            <div class="block-in-page-transparent" v-if="project.MotivationYoutubeLink || project.MotivationVideoPath">
                <video-viewer ref="videoView" :auto="false"></video-viewer>
            </div>
            <div class="block-in-page-transparent" v-if="project.MotivationFile != null">
                <pdf-viewer ref="pdfView"></pdf-viewer>
            </div>
        </div>

        <popup-window ref="ppYoutubeLink" :title="'Добавление видео'" :width="800" v-if="project != null">

                <div class="form-field">
                    <label class="input-text-lbl">
                        Тип видео
                    </label>
                    <drop-down :items="[{Id: 1, Name: 'Youtube ссылка'}, {Id: 2, Name: 'Файл'}]"
                               :dataField="'Id'"
                               :textField="'Name'"
                               v-model="project.MotivationVideoTypeId"></drop-down>
                </div>

                <div class="form-field" v-if="project.MotivationVideoTypeId === 1">
                    <label class="input-text-lbl">
                        URL на ролик на youtube (например, https://www.youtube.com/embed/ID)
                        <span class="required" aria-required="true">*</span>
                    </label>
                    <input name="MotivationYoutubeLink" v-validate="'url'" v-model="project.MotivationYoutubeLink" :class="['input-text', {'input-error': errors.has('MotivationYoutubeLink')}]" type="text">
                    <span class="field-validation-valid">{{ errors.first('MotivationYoutubeLink') }}</span>
                </div>

                <div class="form-field-group margin-top-20 margin-bottom-20" v-if="project.MotivationVideoTypeId === 2">
                    <div class="form-field">
                        <input type="file" :id="'videoDropFiles'" :ref="'videoDropFiles'" :name="'videoDropFiles'"
                               class="file-upload-zone-btn" accept=".mp4" @change="onVideoFileChange($event)" />
                        <button type="button" class="btn" @click="$refs['videoDropFiles'].click()" v-if="project.MotivationVideoName == null || project.DeleteMotivationVideo">
                            Загрузить
                        </button>
                        <div v-if="project.MotivationVideoName != null && !project.DeleteMotivationVideo" class="fileList">
                            Выбран файл: {{ project.MotivationVideoName }}
                        </div>
                        <div class="btns flex">
                            <button type="button" class="btn btn-delete margin-top-15"
                                    @click.stop="removeVideo()"
                                    v-if="project.MotivationVideoName && !project.DeleteMotivationVideo">
                                Удалить
                            </button>
                        </div>
                    </div>
                </div>

            <div class="flex btns">
                <button class="btn margin-top-10" @click.stop="onSaveYoutubeLink">Сохранить</button>
                <button class="btn margin-top-10" @click.stop="closeModal('ppYoutubeLink')">Отмена</button>
            </div>
        </popup-window>

        <vue-headful :title="getPageTitle()" />
    </div>
</template>

<script>
    import $ from 'jquery'
    import config from '../config'
    import projectMixin from '../helpers/project-mixin'
    import claimsCheckingMixin from '../helpers/claims-checking-mixin'
    import UI from '../helpers/ui-helpers'
    import BackendApi from '../backendApi'

    let backendApi = new BackendApi();

    export default {
        name: "motivation",

        props: ['info'],

        data() {
            return {
                project: null
            }
        },

        mixins: [projectMixin, claimsCheckingMixin],

        methods:{

            onFileChange(){
                let vm = this;

                let files = document.getElementById('dropFiles').files;
                if (files.length > 0) {
                    if (window.FormData !== undefined) {
                        let data = new FormData();
                        for (let x = 0; x < files.length; x++) {
                            data.append("file" + x, files[x]);
                        }

                        let tokenInfo = JSON.parse(localStorage.getItem('tokenInfo') == null ? sessionStorage.getItem('tokenInfo') : localStorage.getItem('tokenInfo'));
                        let headers = {};
                        if(tokenInfo != null){
                            headers.Authorization = 'bearer ' + tokenInfo.access_token;
                        }
                        $.ajax({
                            type: "POST",
                            url: config.apiUrl + '/api/project/motivation?projectId=' + vm.projectId,
                            contentType: false,
                            processData: false,
                            headers: headers,
                            data: data,
                            success: function (resp) {
                                if (resp.hasError) {
                                    UI.toastr.error('Ошибка загрузки');
                                }
                                else {
                                    UI.toastr.success('Успешно загружено');

                                    vm.project.MotivationFile = resp.result;
                                    let url = resp.result;
                                    vm.$nextTick(()=>{
                                        vm.$refs['pdfView'].show(url);
                                    });
                                }
                            },
                            error: function (xhr, status, p3) {
                                UI.toastr.error(xhr.responseText);
                            }
                        });
                    } else {
                        UI.toastr.error('Браузер не поддерживает загрузку файлов HTML5!');
                    }
                }
            },

            onVideoFileChange($event){
                let vm = this;
                let files = $event.target.files;
                if (files.length > 0) {
                    if (window.FormData !== undefined) {
                        let data = new FormData();
                        for (let x = 0; x < files.length; x++) {
                            data.append("file" + x, files[x]);
                        }
                        let tokenInfo = JSON.parse(localStorage.getItem('tokenInfo') == null ? sessionStorage.getItem('tokenInfo') : localStorage.getItem('tokenInfo'));
                        let headers = {};
                        if(tokenInfo != null){
                            headers.Authorization = 'bearer ' + tokenInfo.access_token;
                        }

                        UI.blockUI('#app');
                        $.ajax({
                            type: "POST",
                            url: config.apiUrl + '/api/project/loadVideo?projectId=' + vm.project.Id,
                            contentType: false,
                            processData: false,
                            headers: headers,
                            data: data,
                            success: function (resp) {
                                if (resp.hasError) {
                                    UI.toastr.error('Ошибка загрузки видео');
                                }
                                else {
                                    let data = resp.result;
                                    vm.project.MotivationVideoName = data.FileName;
                                    vm.project.DeleteMotivationVideo = false;
                                }
                                UI.unblockUI('#app');
                            },
                            error: function (xhr, status, p3) {
                                UI.toastr.error('Ошибка на сервере');
                                console.error(xhr.responseText);
                                UI.unblockUI('#app');
                            }
                        });
                    } else {
                        UI.toastr.error('Браузер не поддерживает загрузку файлов HTML5!');
                    }
                }
            },

            removeVideo(){
                this.project.DeleteMotivationVideo = true;
            },

            loadProject() {
                let vm = this;

                return vm.callApiWrapper(backendApi.projectLoad(vm.projectId)).then(function (response) {
                    console.info('project reloaded')
                    if (response.hasError) {
                        UI.toastr.error('Ошибка при загрузке проекта');
                    }
                    else {
                        let obj = response.data;
                        obj.DeleteMotivationVideo = false;
                        if(obj.MotivationVideoName){
                            obj.MotivationVideoTypeId = 2;
                        }
                        else{
                            obj.MotivationVideoTypeId = 1;
                        }

                        vm.project = obj;//Object.assign({}, vm.project, obj);

                        vm.$nextTick(() => {
                            if (vm.project.MotivationFile) {
                                let url = vm.project.MotivationFile;
                                vm.$refs['pdfView'].show(url);
                            }

                            if (vm.project.MotivationYoutubeLink) {
                                vm.$refs['videoView'].show(vm.project.MotivationYoutubeLink, 0, 0, true);
                            }

                            if (vm.project.MotivationVideoPath) {
                                vm.$refs['videoView'].show(vm.project.MotivationVideoPath, 0);
                            }
                        });
                    }
                })
            },

            onProjectChange(item){
                let vm = this;

                vm.projectId = item.Id;

                location.reload();
                // UI.blockUI('#app');
                // vm.loadProject().then(()=>{
                //     UI.unblockUI('#app');
                //     vm.$emit('user-updated');
                // });
            },

            deleteMotivation(){
                let vm = this;
                if(confirm('Вы уверены что хотите удалить файл?')) {
                    UI.blockUI('.dataContent', 'Удаление...');
                    vm.callApiWrapper(backendApi.motivationDelete(vm.projectId)).then(function (response) {
                        UI.unblockUI('.dataContent');
                        if (response.hasError) {
                            UI.toastr.error('Ошибка при удалении файла');
                        } else {
                            UI.toastr.success('Успешно удалено');
                            vm.project.MotivationFile = null;
                        }
                    });
                }
            },

            onDeleteYoutubeLink(){
                let vm = this;
                if(confirm('Вы уверены что хотите удалить видео?')) {

                    vm.project.MotivationYoutubeLink = null;
                    vm.project.MotivationVideoPath= null;
                    vm.project.MotivationVideoName= null;

                    this.saveLink().then(function (response) {
                        if(!response.hasError){
                        }
                    });
                }
            },

            onSaveYoutubeLink(){
                let vm = this;

                this.$validator.validate().then(result => {
                    if (!result) {
                        UI.toastr.error('Проверьте введённые данные');
                    }
                    else {
                        vm.saveLink().then(function (response) {
                            if(!response.hasError){

                                vm.closeModal('ppYoutubeLink');
                                vm.loadProject();
                            }
                        });
                    }
                });
            },

            saveLink(){
                let vm = this;
                UI.blockUI('#app', '');
                if(vm.project.MotivationVideoTypeId === 1){
                    vm.project.MotivationVideoName = null;
                }
                else{
                    vm.project.MotivationYoutubeLink = null;
                }
                if(vm.project.DeleteMotivationVideo){
                    vm.project.MotivationVideoName = null;
                    vm.project.MotivationVideoPath = null;
                }
                return vm.callApiWrapper(backendApi.motivationYoutubeLinkSave(vm.projectId, vm.project.MotivationYoutubeLink, vm.project.MotivationVideoName)).then(function (response) {
                    UI.unblockUI('#app');
                    if (response.hasError) {
                        UI.toastr.error('Ошибка при обновлении видео');
                    } else {
                        UI.toastr.success('Успешно выполнено');
                    }

                    return response;
                });
            }
        },

        mounted(){
            UI.blockUI('.dataContent', 'Загрузка...');
            this.loadProject().then(() => {
                UI.unblockUI('.dataContent');
            });
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// Content/src/views/Motivation.vue